String.prototype.toKebabCase = function (str) {
  if (!str) str = this;
  return str.toLowerCase().replace(/\s+/g, '-');
};

String.prototype.toSlug = function (str) {
  if (!str) str = this;
  return str.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
};

Number.prototype.countDecimals = function () {
  if (Math.floor(this.valueOf()) === this.valueOf()) return 0;
  return this.toString().split(".")[1].length || 0;
};

require('focus-visible');